import { useState } from 'react';

export interface DashboardFilters {
  year: number | 'all';
  divisionIds: string[]; // empty array = all divisions
}

export function useDashboardFilters() {
  const currentYear = new Date().getFullYear();
  
  const [filters, setFilters] = useState<DashboardFilters>({
    year: currentYear,
    divisionIds: [],
  });

  const updateYear = (year: number | 'all') => {
    setFilters(prev => ({ ...prev, year }));
  };

  const toggleDivision = (divisionId: string) => {
    setFilters(prev => ({
      ...prev,
      divisionIds: prev.divisionIds.includes(divisionId)
        ? prev.divisionIds.filter(id => id !== divisionId)
        : [...prev.divisionIds, divisionId],
    }));
  };

  const resetFilters = () => {
    setFilters({
      year: currentYear,
      divisionIds: [],
    });
  };

  const hasActiveFilters = filters.year !== currentYear || filters.divisionIds.length > 0;

  return {
    filters,
    updateYear,
    toggleDivision,
    resetFilters,
    hasActiveFilters,
  };
}
